import { render, staticRenderFns } from "./QuoteAttachment.vue?vue&type=template&id=16f47832"
import script from "./QuoteAttachment.vue?vue&type=script&lang=js"
export * from "./QuoteAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports